import {AnyAction} from "redux";
import {LoadingState} from "./index";
import {RequestOptions} from "../types/Types";
import {POST_SESSION_BASE, RESET_SUBMIT_STATE} from "../actions/login";

/**
 * Provide a way to store all loading events in one place
 * Example: https://medium.com/stashaway-engineering/react-redux-tips-better-way-to-handle-loading-flags-in-your-reducers-afda42a804c6
 *
 * @param {LoadingState} state
 * @param {AnyAction} action
 * @returns {LoadingState}
 */

const loading = (state: LoadingState = {}, action: AnyAction) => {
  const {type} = action;
  const options: RequestOptions = action.options;

  // When navigating to 2FA, POST_SESSION never gets a SUCCESS/FAILURE.
  // Clear its loading state here so the login screen doesn't show a stale spinner.
  if (type === RESET_SUBMIT_STATE) {
    return {
      ...state,
      [POST_SESSION_BASE]: { showLoader: false }
    };
  }

  const typeMatches = (/(.*)_(BEGIN|SUCCESS|FAILURE)/).exec(type);
  if (!typeMatches) {
    return state;
  }

  const shouldShowLoader = options && !options.hideLoader;

  const [, requestName, requestState] = typeMatches;

  return {
    ...state,
    [requestName]: {
      showLoader: requestState === "BEGIN" && shouldShowLoader
    }
  };
};

export default loading;
